import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Arrow: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666', style = {} }) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} style={style} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0007621,13.0865485 L16.3127232,8.77458739 C16.6788397,8.40847087 17.2724319,8.40847087 17.6385484,8.77458739 L17.7269368,8.86297574 C18.0930533,9.22909226 18.0930533,9.82268443 17.7269368,10.188801 L12.688801,15.2269368 C12.4993518,15.4163859 12.2489938,15.5078035 12.0007621,15.5011895 C11.7525304,15.5078035 11.5021723,15.4163859 11.3127232,15.2269368 L6.27458739,10.188801 C5.90847087,9.82268443 5.90847087,9.22909226 6.27458739,8.86297574 L6.36297574,8.77458739 C6.72909226,8.40847087 7.32268443,8.40847087 7.68880096,8.77458739 L12.0007621,13.0865485 Z"
        fill={fill}
      />
    </svg>
  );
};

export default Arrow;
